export default {"src":"/_next/static/media/bgcolorblur.caf12eed.svg","height":1676,"width":1829,"blurWidth":0,"blurHeight":0};